function formatToMonthYear(dateString) {
    const date = new Date(dateString);
    const month = date.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
    const year = date.getUTCFullYear().toString().slice(-2);
    return `${month} ’${year}`;
}

export default formatToMonthYear;
